module.exports = __webpack_public_path__ + "static/media/JYULogo.f140c574.svg";